import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import { SearchIcon } from '@domain-group/fe-co-icon';
import Loader from '@domain-group/fe-co-loader';
import * as autocompletePropTypes from '../../utils/prop-types';
import * as styles from './modal-placeholder.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ModalPlaceholder = _ref => {
  var placeholder = _ref.placeholder,
    hideButton = _ref.hideButton,
    pending = _ref.pending,
    invalid = _ref.invalid,
    onClick = _ref.onClick,
    embeddedComponent = _ref.embeddedComponent,
    _ref$selectedItems = _ref.selectedItems,
    selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems;
  var valueText = selectedItems.length > 0 && "".concat(selectedItems[0].name).concat(selectedItems.length > 1 ? " + ".concat(selectedItems.length - 1, " location").concat(selectedItems.length > 2 ? 's' : '') : '');
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.placeholder, invalid && styles.invalid, pending && styles.disabled])
  }, ___EmotionJSX("button", {
    disabled: pending,
    css: styles.button,
    type: "button",
    onClick: onClick
  }, !hideButton && pending ? ___EmotionJSX(Loader, {
    transparent: true,
    css: styles.loader,
    size: "mini"
  }) : ___EmotionJSX(SearchIcon, {
    css: styles.icon,
    size: "custom"
  }), ___EmotionJSX("span", {
    css: /*#__PURE__*/_css([styles.placeholderText, valueText && styles.valueText])
  }, valueText || placeholder)), embeddedComponent);
};
ModalPlaceholder.propTypes = {
  selectedItems: autocompletePropTypes.valueList,
  placeholder: PropTypes.string,
  hideButton: PropTypes.bool,
  embeddedComponent: PropTypes.node,
  pending: PropTypes.bool,
  invalid: PropTypes.bool,
  onClick: PropTypes.func
};
ModalPlaceholder.defaultProps = {
  selectedItems: [],
  placeholder: '',
  hideButton: false,
  embeddedComponent: undefined,
  pending: false,
  invalid: false,
  onClick: () => {}
};
export default ModalPlaceholder;